import React, { useState } from 'react'
import { TabletAndLarger } from '../../shared/responsive-breakpoints'
import HomeValueSolutionsList from './HomeValueSolutionsList'

const { PUBLIC_URL } = process.env

const HomeValueSolutions = ({ valueSolutionsData }) => {
  const { header, linkText, slogan } = valueSolutionsData
  const [activeAccordion, setActiveAccordion] = useState(valueSolutionsData.accordions[0].fields)

  const changeActiveAccordion = newAccordion => {
    if (activeAccordion === newAccordion) {
      setActiveAccordion({})
      return
    }
    setActiveAccordion(newAccordion)
  }

  return (
    <section className="dealmed-home-solutions" aria-labelledby="dealmed-home-solutions-heading">
      <div className="dealmed-container">
        <span className="dealmed-home-solutions__span">{header}</span>
        <h2 className="dealmed-home-solutions__heading" id="dealmed-home-solutions-heading">
          {slogan}
        </h2>
        <div className="dealmed-home-solutions__wrapper">
          <TabletAndLarger>
            <div className="dealmed-home-solutions__banner">
              <img
                src={
                  activeAccordion.accordionImage?.fields?.file?.url ??
                  `${PUBLIC_URL}/images/homepage-tablet-1.png`
                }
                className="dealmed-home-solutions__banner-image"
                alt=""
                loading="lazy"
              />
            </div>
          </TabletAndLarger>
          <div className="dealmed-home-solutions__accordions">
            <HomeValueSolutionsList
              accordions={valueSolutionsData.accordions.map(accordion => accordion.fields)}
              activeAccordion={activeAccordion}
              changeActiveAccordion={changeActiveAccordion}
              linkText={linkText}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeValueSolutions
